import PropTypes from "prop-types";
import React, {
	PureComponent
} from "react";
import {
	View,
	Platform,
	PermissionsAndroid,
	Alert
} from "react-native";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import ErrorMessage from "./Layout/ErrorMessage";

import StyledButton from "ae-base/Base/StyledButton";
import Indicator from "ae-base/Base/Indicator";
import StyledText from "ae-base/Base/StyledText";
import ListItem from "ae-base/List/ListItem";

import Input from "./Input";

import ResponsiveStylesheet from "react-native-responsive-stylesheet";
import { useResources } from "@aetonix/hooks";

const styles = ResponsiveStylesheet.createSized("min-width", {
	0: {
		main: {
			flexDirection: "row",
			flex: 1,
			justifyContent: "space-between"
		},
		marginLeft: {
			marginLeft: 4
		},
		buttonContainer: {
			flexDirection: "row"
		}
	}, 512: {
		mainContent: {
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center"
		}
	}
});

class BluetoothScannerComp extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			scanning: false,
			devices: [],
			selected: "",
			hasChanged: false
		};

		this.handleClear = handleClear.bind(this);
		this.handleScanned = handleScanned.bind(this);
		this.handleSelect = handleSelect.bind(this);
		this.handleCancel = handleCancel.bind(this);

		this.initateScan = initiateScan.bind(this);
		this.handleScan = handleScan.bind(this);

		this.onChangeText = onChangeText.bind(this);
	}

	componentDidMount() {
		const listen = this.props.listen;
		listen("bluetooth:scanned", this.handleScanned);
		listen("managedbluetoothscanner:scanned", this.handleScanned);

	}

	componentWillUnmount() {
		const unlisten = this.props.unlisten;
		unlisten("bluetooth:scanned", this.handleScanned);
		unlisten("managedbluetoothscanner:scanned", this.handleScanned);
	}

	render() {
		const props = this.props;
		const state = this.state;
		const localize = props.localize;

		const defaultValue = props.defaultValue;
		const hasChanged = state.hasChanged;
		const schema = props.schema || {};
		const errors = props.errors;
		const scanning = state.scanning;
		const devices = state.devices;
		const selected = state.selected;
		const managed = schema.managed;

		let noEdit = false;

		if (!managed && Platform.OS === "ios") noEdit = true;

		const displayValue = hasChanged ? selected : defaultValue;

		let renderScanButton = null;
		let renderScanning = null;

		const renderFoundDevices = devices.map((device) =>
			<Device key={device.id} device={device} onSelect={this.handleSelect} />
		);

		const scanTitle = localize("managedbracelet.scan");
		const cancelTitle = localize("managedbracelet.cancel");
		const clearTitle = localize("managedbracelet.clear");

		if (!scanning) {
			renderScanButton = (
				<View style={styles.marginLeft}>
					<StyledButton title={scanTitle} onPress={this.initateScan} />
				</View>
			);
		} else {
			renderScanButton = (
				<View style={styles.marginLeft}>
					<StyledButton title={cancelTitle} onPress={this.handleCancel} />
				</View>
			);
			renderScanning = (
				<View accessibilityRole="progressbar" accessibilityLabel="Progress Bar">
					<Indicator />
					{renderFoundDevices}
				</View>
			);
		}

		return (
			<InputContainer inline={props.inline} errors={props.errors} stretch={schema.stretch}>
				<InputLabel schema={schema} />
				<View style={styles.mainContent}>
					<View style={styles.buttonContainer}>
						<StyledButton style={styles.marginLeft} title={clearTitle} onPress={this.handleClear} />
						{renderScanButton}
					</View>
				</View>
				<View>
					<ErrorMessage id={this.props.id + "_error"} errors={errors} schema={schema} />
					<Input schema={{}} ariaLabel={"Blutooth Scanner"} value={displayValue} onChange={this.onChangeText} noEdit={noEdit} />
				</View>
				{renderScanning}
			</InputContainer>
		);
	}
}

function Device(props) {
	const { localize } = useResources();
	const device = props.device;
	const name = device.name;
	const id = device.id;

	const selectTitle = localize("bluetoothscanner.selectTitle");

	const onSelect = function selectDevice() {
		props.onSelect(device);
	};

	return (
		<ListItem>
			<View style={styles.main}>
				<View>
					<StyledText bold>{name}</StyledText>
					<StyledText small>{id}</StyledText>
				</View>
				<View>
					<StyledButton title={selectTitle} onPress={onSelect} />
				</View>
			</View>
		</ListItem>
	);
}

function handleClear() {
	const onChange = this.props.onChange;
	if (onChange) onChange("");
	this.setState({
		selected: ""
	});
}

function handleScanned(device) {
	const current = this.state.devices;
	let newList = current;
	if (!findDevice(device, current))
		newList = current.concat(device);

	this.setState({
		devices: newList
	});
}

function handleSelect(device) {
	const mac = device.id;
	const onChange = this.props.onChange;
	if (onChange) onChange(mac);
	this.setState({
		selected: mac,
		hasChanged: true
	});
	this.handleCancel();
}

function handleCancel() {
	const dispatch = this.props.dispatch;

	const schema = this.props.schema || {};
	const managed = schema.managed;

	let stopScan = dispatch("bluetooth:trigger:scan:stop");
	if (managed) stopScan = dispatch("managedbluetoothscanner:trigger:stop:scan");

	stopScan();
	this.setState({
		devices: [],
		scanning: false
	});
}

function initiateScan() {
		if (Platform.OS === "android") {
			PermissionsAndroid.request(
				PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION
			).then((granted) => {
				switch (granted) {
					case PermissionsAndroid.RESULTS.GRANTED:
						this.handleScan();
						break;

					case PermissionsAndroid.RESULTS.DENIED:
					case PermissionsAndroid.RESULTS.NEVER_ASK_AGAIN:
						Alert.alert("", this.props.localize("devices.requirelocationperm"), [{
							text: "Ok",
							onPress: () => { }
						}]);
						break;
				}
			}).catch((err) => {
				console.error(err);
			});

		}
		else {
			this.handleScan();
		}
};

function handleScan() {

	const dispatch = this.props.dispatch;

	const schema = this.props.schema || {};
	const managed = schema.managed;

	let startScan = dispatch("bluetooth:trigger:scan");
	if (managed) startScan = dispatch("managedbluetoothscanner:trigger:start:scan");

	startScan();
	this.setState({
		scanning: true
	});
}

function onChangeText(text) {
	const onChange = this.props.onChange;
	if (onChange) onChange(text);
	this.setState({
		selected: text,
		hasChanged: true
	});
}

function findDevice(device, devices) {
	return devices.reduce((acc, dev) => {
		const findId = device.id;
		const eleId = dev.id;
		if (findId === eleId) acc = true;
		return acc;
	}, false);
}

export default function BluetoothScanner(props){
	const { localize, dispatch, listen, unlisten } = useResources();
	return (
		<BluetoothScannerComp
			{...props}
			localize={localize}
			dispatch={dispatch}
			listen={listen}
			unlisten={unlisten}
		/>
	);

}